import styled from "styled-components";
import Box from "@material-ui/core/Box";
import { breakpointTheme } from "Custom/StylesAppSpecific/AppStyling";
import OldhamProject_5 from "Custom/Content/User/Oldham-Project-5.jpg";
import OldhamProject_5_300x200 from "Custom/Content/User/Oldham-Project-5-300x200.jpg";
import Oldham_Project_5_370x247 from "Custom/Content/User/Oldham-Project-5-370x247.jpg";

export const DescriptionImageBox: any = styled(Box)`
    background-position-x: 0%;
    background-position-y: 0%;
    background-size: auto;
    background-repeat: no-repeat;
    background-origin: padding-box;

    @media only screen and (max-width: ${breakpointTheme.breakpoints.values.md + "px"}) {
        background-image: url(${OldhamProject_5_300x200});
        height: 115px;
    }
    @media only screen and (min-width: ${breakpointTheme.breakpoints.values.md + "px"}) and (max-width: ${breakpointTheme.breakpoints.values.lg + "px"}) {
        background-image: url(${Oldham_Project_5_370x247});
        height: 115px;
    }
    @media only screen and (min-width: ${breakpointTheme.breakpoints.values.lg + "px"}) {
        background-image: url(${OldhamProject_5});
    }
`;
